import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<MiStepDialog>({ })

export default class MiStepDialog extends Vue {
  @Prop()
  protected options!: MiStepDialogOptions;

  protected isSubmitted = false;

  @Prop({ default: false })
  protected isSuccessful!: boolean;

  @Prop({ default: 'Item was successfully created' })
  protected successfulText!: string;

  @Prop({ default: false })
  protected isFailed!: boolean;

  @Prop({ default: 'An unexpected error occured....' })
  protected failedText!: string;

  public currentStep = 1;

  protected validStep = false;

  protected mounted(): void {
    if (! this.options) {
      return;
    }
    console.log(`MiStepComponent mounted with ${this.options.steps} steps`);
  }

  protected handleStepClick(step: number): void {
    if (this.isLinear && step > this.currentStep) {
      return;
    }

    this.currentStep = step;
    this.$emit('stepChanged', this.currentStep);
  }

  protected handlePreviousStep(): void {
    this.currentStep -= 1;
    this.$emit('previousStep', this.currentStep);
  }

  protected handleNextStep(): void {
    if (this.currentStep < this.options.steps) {
      this.currentStep += 1;
      this.$emit('nextStep', this.currentStep);
      return;
    }

    this.isSubmitted = true;
    this.$emit('stepperCompleted');
  }

  public setValid(valid: boolean): void {
    this.validStep = valid;
  }

  protected close(): void {
    this.$emit('input', false);
  }

  protected get completeLabel(): string {
    if (! this.options || ! this.options.completeLabel) {
      return 'Complete';
    }

    return this.options.completeLabel;
  }

  protected get isLinear(): boolean {
    let linear = true;

    if (this.options && this.options.linear !== undefined) {
      linear = this.options.linear;
    }

    return linear;
  }
}

export interface MiStepDialogOptions {
  steps: number;
  linear?: boolean;
  hasValidation?: boolean;
  completeLabel?: string;
  fullscreen?: boolean;
  hideProgress: boolean;
}
